import { createSelector } from "reselect";
import { Record } from "immutable";

import { ContractCancellationReasonsState } from "@typings/contractCancellation";

import { IStore } from "@app/redux/reducers";

const getAccountBalanceFunction = (store: IStore) =>
  store.profile.get("accountBalance");

export const getAccountBalance = createSelector(
  getAccountBalanceFunction,
  f => f,
);

const getAccountBalanceLoadingStateFunction = (store: IStore) =>
  store.profile.get("accountBalanceLoadingState");

export const getAccountBalanceLoadingState = createSelector(
  getAccountBalanceLoadingStateFunction,
  f => f,
);

const getReferralFunction = (store: IStore) => store.profile.get("referral");

export const getReferral = createSelector(getReferralFunction, f => f);

const getBasicInfoFunction = (store: IStore) => store.profile.get("basicInfo");

export const getBasicInfo = createSelector(getBasicInfoFunction, f => f);

const getCompanyInfoFunction = (store: IStore) =>
  store.profile.get("companyInfo");

export const getCompanyInfo = createSelector(getCompanyInfoFunction, f => f);

const getPaymentAliasesLoadingStateFunction = (store: IStore) =>
  store.profile.get("paymentAliasesLoadingState");

export const getPaymentAliasesLoadingState = createSelector(
  getPaymentAliasesLoadingStateFunction,
  f => f,
);

const getPaymentAliasesFunction = (store: IStore) =>
  store.profile.get("paymentAliases");

export const getPaymentAliases = createSelector(
  getPaymentAliasesFunction,
  f => f,
);

const getDefaultPaymentAliasFunction = (store: IStore) =>
  store.profile.get("paymentAliases").find(el => el.get("default"));

export const getDefaultPaymentAlias = createSelector(
  getDefaultPaymentAliasFunction,
  f => f,
);

const getSubscriptionsFunction = (store: IStore) =>
  store.profile.get("subscriptions");

export const getSubscriptions = createSelector(
  getSubscriptionsFunction,
  f => f,
);

const getContractsFunction = (store: IStore) => store.profile.get("contracts");
export const getContracts = createSelector(getContractsFunction, f => f);

export const getContractById = (contractUuid: string) =>
  createSelector(getContractsFunction, f =>
    f.find(el => el.get("contractUuid") === contractUuid),
  );

const getContractsLoadingStateFunction = (store: IStore) =>
  store.profile.get("contractsLoadingState");

export const getContractsLoadingState = createSelector(
  getContractsLoadingStateFunction,
  f => f,
);

const getContractCancellationReasons = (
  store: IStore,
): { [key: string]: Record<ContractCancellationReasonsState> } =>
  store.profile.get("contractCancellationReasons");

export const getContractChangeRequestRelativeUrl = (contractUuid: string) =>
  createSelector(getContractCancellationReasons, f =>
    f[contractUuid]?.get("changeRequestRelativeUrl"),
  );

export const getContractCancellationReason = (contractUuid: string) =>
  createSelector(getContractCancellationReasons, f =>
    f[contractUuid]?.get("reasons"),
  );

const getReviewInfoFunction = (store: IStore) =>
  store.profile.get("reviewInfo");

export const getReviewInfo = createSelector(getReviewInfoFunction, f => f);

const getReviewInfoLoadingStateFunction = (store: IStore) =>
  store.profile.get("reviewInfoLoadingState");

export const getReviewInfoLoadingState = createSelector(
  getReviewInfoLoadingStateFunction,
  f => f,
);
